"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkUnlimited = checkUnlimited;
exports.daysToMonths = daysToMonths;
exports.findGiftsData = findGiftsData;
exports.getBenefitsIconsWithTitles = getBenefitsIconsWithTitles;
exports.isArrayValid = isArrayValid;
var _jsonpathPlus = require("jsonpath-plus");
var _r10CommonComponents = require("r10-common-components");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function checkUnlimited(t, unlimitedValue, amount) {
  if (amount === unlimitedValue) {
    return t('unlimited');
  }
  return amount;
}
function checkUnlimitedDataText(t, unlimitedValue, amount) {
  if (amount === unlimitedValue) {
    return t('unlimited');
  }
  return _r10CommonComponents.utils.formatMB(amount);
}
function daysToMonths(t, days, unit) {
  if (unit !== 'days') return "".concat(t('for'), " ").concat(days, " ").concat(unit);
  if (days < 30) return "".concat(t('for'), " ").concat(days, " ").concat(t('days'));
  if (days === 30) return "".concat(t('for'), " 1 ").concat(t('month'));
  return "".concat(t('for'), " ").concat(Math.round(days / 30), " ").concat(t('months'));
}
function getGiftsDetails(giftProduct) {
  var giftProductDataFounded = {
    flag: true,
    gifts: {}
  };

  // get gift items`
  if ((giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.productCharacteristic) != null) {
    giftProduct.productCharacteristic.map(function (gift) {
      if (gift.name !== 'specialOfferFlg') {
        giftProductDataFounded.gifts[gift.name] = gift.value;
      }
    });
  }

  // get gift duration
  if ((giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.productTerm) != null) {
    giftProduct.productTerm.map(function (term) {
      if (term.name === 'bundleDuration') {
        giftProductDataFounded.durationAmount = term.duration.amount;
        giftProductDataFounded.durationUnits = term.duration.units;
      }
    });
  }
  return giftProductDataFounded;
}
function isArrayValid() {
  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return field && (field === null || field === void 0 ? void 0 : field.length) > 0;
}

// Filter response for gifts
function findGiftsData(campaignDetails) {
  var _campaignDetails$;
  var giftProductData = {
    flag: false,
    gifts: {}
  };
  var giftProduct = null;
  var giftObjectFound = false;
  if (!campaignDetails[0] || !((_campaignDetails$ = campaignDetails[0]) !== null && _campaignDetails$ !== void 0 && _campaignDetails$.recommendationItem[0])) return giftProductData;
  campaignDetails.map(function (ob) {
    ob.recommendationItem.map(function (entry, index) {
      if (entry.product.productCharacteristic != null) {
        entry.product.productCharacteristic.map(function (productEntry) {
          if (productEntry.name === 'specialOfferFlg' && productEntry.value === 'true') {
            var _JSONPath = (0, _jsonpathPlus.JSONPath)({
                path: "$.recommendationItem[".concat(index, "].product"),
                json: campaignDetails[0]
              }),
              _JSONPath2 = _slicedToArray(_JSONPath, 1),
              giftProductExtr = _JSONPath2[0];
            giftProduct = giftProductExtr;
            giftObjectFound = true;
          }
        });
      }
    });
  });
  if (giftObjectFound) return getGiftsDetails(giftProduct);
  return giftProductData;
}
function getBenefitsIconsWithTitles(t) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var voice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var voiceVf = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var sms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var unlimitedValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '999999';
  var benefits = [];
  if (data) {
    benefits.push({
      icon: 'data',
      title: "".concat(checkUnlimitedDataText(t, unlimitedValue, data), " ").concat(t('data'))
    });
  }
  if (voice) {
    benefits.push({
      icon: 'call',
      title: "".concat(checkUnlimited(t, unlimitedValue, voice), " ").concat(t('minutes'))
    });
  }
  if (voiceVf) benefits.push({
    icon: 'call',
    title: "".concat(checkUnlimited(t, unlimitedValue, voiceVf), " ").concat(t('minutesVF'))
  });
  if (sms) benefits.push({
    icon: 'sms',
    title: "".concat(checkUnlimited(t, unlimitedValue, sms), " ").concat(t('sms'))
  });
  return benefits;
}